export default __webpack_public_path__ + "static/media/correct.b99a006a.mp3";